module.exports = __webpack_public_path__ + "static/media/vehicle-details.94053681.svg";